// test149
(149 && 0);
